import { cn } from '@/lib/utils';
import type { IFilterTabsProps } from '@/@types/posts';

function FilterTabs({ tabs, activeTab, onTabChange, className }: IFilterTabsProps) {
  return (
    <div
      className={cn(
        'flex items-center rounded-lg bg-background-card p-1',
        className
      )}
    >
      {tabs.map((tab) => {
        const isActive = tab.id === activeTab;
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={cn(
              'flex items-center gap-2 rounded-md px-4 py-2 text-[13px] font-medium transition-colors',
              isActive
                ? 'bg-border text-foreground'
                : 'text-foreground-muted hover:text-foreground'
            )}
          >
            <span>{tab.label}</span>
            <span
              className={cn(
                'text-[12px]',
                isActive ? 'text-foreground-muted' : 'text-foreground-placeholder'
              )}
            >
              {tab.count}
            </span>
          </button>
        );
      })}
    </div>
  );
}

export { FilterTabs };
